import { store } from '@Core/Communication'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-loading-skeleton/dist/skeleton.css'
import { Provider as ReduxProvider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './globals.css'
import './index.css'

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://0ea66d2403d84b9d98ce765d491d52eb@o594431.ingest.sentry.io/4504833860304896',
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1.0,
        // Propaga o trace (sentry-trace/baggage) só para a nossa API
        tracePropagationTargets: [
            import.meta.env.VITE_BASE_URL_API ||
                'https://api-ofc.buzato.dev.br',
        ],
    })
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <ReduxProvider store={store}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </ReduxProvider>
    </React.StrictMode>
)
